import * as HighCharts from 'highcharts/highstock'; // tslint:disable-line
import { Component } from 'react';

// Map button index to time period key
const TIME_PERIOD_MAP: { [key: number]: string } = {
  0: '1M',
  1: '3M',
  2: '6M',
  3: '1Y',
  4: '3Y',
  5: '5Y',
  6: 'MAX',
};

class LinearChart extends Component<any> {
  private chart: any;

  public componentDidMount() {
    this.loadChart();
    // Notify parent of initial selected time period (3Y is default, index 4)
    if (this.props.onTimePeriodChange) {
      this.props.onTimePeriodChange(TIME_PERIOD_MAP[4]);
    }
  }

  public loadChart() {
    const {
      graphData,
      categoryData,
      graphConfig,
      category,
      onTimePeriodChange,
    } = this.props;

    this.chart = new HighCharts.StockChart('chart-container', {
      ...graphConfig,
      chart: {
        events: {
          redraw() {
            const chart = this as any;
            if (
              chart.rangeSelector &&
              chart.rangeSelector.selected !== undefined
            ) {
              const selectedIndex = chart.rangeSelector.selected;
              if (TIME_PERIOD_MAP[selectedIndex] && onTimePeriodChange) {
                onTimePeriodChange(TIME_PERIOD_MAP[selectedIndex]);
              }
            }
          },
        },
      },
      navigator: {
        enabled: false,
      },
      scrollbar: {
        enabled: false,
      },
      rangeSelector: {
        inputEnabled: false,
        buttons: [
          { type: 'month', count: 1, text: '1M' },
          { type: 'month', count: 3, text: '3M' },
          { type: 'month', count: 6, text: '6M' },
          { type: 'year', count: 1, text: '1Y' },
          { type: 'year', count: 3, text: '3Y' },
          { type: 'year', count: 5, text: '5Y' },
          { type: 'all', text: 'Max' },
        ],
        selected: 4,
        labelStyle: {
          display: 'none',
        },
      },
      credits: {
        enabled: false,
      },
      yAxis: {
        labels: {
          enabled: false,
        },
        gridLineWidth: 0,
        title: {
          text: null,
        },
      },
      series: [
        {
          name: 'Fund',
          data: graphData || [],
          tooltip: {
            valueDecimals: 2,
          },
        },
        {
          name: category,
          data: categoryData || [],
          tooltip: {
            valueDecimals: 2,
          },
          visible: false,
        },
      ],
    });
  }

  public componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  public render() {
    return (
      <div
        id="chart-container"
        style={{
          minWidth: 310,
          height: 400,
          margin: '0 auto',
        }}
      />
    );
  }
}

export default LinearChart;



// WEBPACK FOOTER //
// ./components/singleFund/LinearChart.tsx